const optionColumnsWithNegativeValue = {
  chart: {
    toolbar: { show: false },
  },

  legend: { show: false },
  dataLabels: {
    enabled: false,
  },
  tooltip: {
    x: {
      format: 'MM/yy',
    },
    y: {
      formatter: (value: number) => {
        let x;
        if (value > 0) {
          x = '+' + value.toFixed(2);
        } else {
          x = value.toFixed(2);
        }
        return x + '%';
      },
    },
    marker: {
      show: false,
    },
  },
  yaxis: {
    labels: {
      formatter(val: number) {
        return val.toFixed(0) + '%';
      },
    },
  },

  plotOptions: {
    bar: {
      colors: {
        ranges: [
          {
            from: -10000000,
            to: 0,
            color: '#DC2638',
          },
          {
            from: 0,
            to: 99999999,
            color: '#16A34A',
          },
        ],
      },
      columnWidth: '80%',
    },
  },
};

export default optionColumnsWithNegativeValue;
